/* Cat-in-a-box theme — scripts */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const PP = window.PP || {};
  const icons = PP.icons || { plus: '+', minus: '&minus;' };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const root = (PP.routes && PP.routes.root) || '/';
  const url = (p) => root.replace(/\/$/, '') + p;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || PP.moneyFormat || '{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    const fmt = (n, d, t, dec) => {
      const fixed = (n / 100).toFixed(d);
      const parts = fixed.split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? dec + parts[1] : '');
    };
    const out = format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
    return out.replace(/<[^>]*>/g, '');
  }

  /* ---------- Panels (menu + cart drawers) ---------- */
  const overlay = $('[data-overlay]');
  let openEl = null;
  let lastFocus = null;

  function openPanel(el) {
    if (!el) return;
    if (openEl && openEl !== el) closePanel(false);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.classList.add('pp-lock');
    openEl = el;
    window.setTimeout(() => {
      const target = el.querySelector('[data-autofocus]') || el.querySelector('button, a[href], input');
      if (target) target.focus();
    }, 60);
  }
  function closePanel(restore = true) {
    if (!openEl) return;
    openEl.classList.remove('is-open');
    openEl.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.classList.remove('pp-lock');
    openEl = null;
    $$('[data-nav-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (restore && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (overlay) overlay.addEventListener('click', () => closePanel());
  document.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) closePanel(); });

  // Keep keyboard focus inside an open drawer
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (openEl) closePanel(); else closeSearch(true);
      return;
    }
    if (e.key !== 'Tab' || !openEl) return;
    const items = $$('a[href], button:not([disabled]), input, textarea, select', openEl).filter((n) => n.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Header: scroll state, menu, search ---------- */
  const header = $('[data-header]');
  const onScroll = () => { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const nav = $('[data-nav]');
  $$('[data-nav-open]').forEach((b) => b.addEventListener('click', () => { b.setAttribute('aria-expanded', 'true'); openPanel(nav); }));

  const search = $('[data-search]');
  const searchBtn = $('[data-search-open]');
  function closeSearch(focusBtn) {
    if (!search || search.hidden) return;
    search.hidden = true;
    if (searchBtn) { searchBtn.setAttribute('aria-expanded', 'false'); if (focusBtn) searchBtn.focus(); }
  }
  if (searchBtn && search) {
    searchBtn.addEventListener('click', () => {
      if (search.hidden) {
        search.hidden = false;
        searchBtn.setAttribute('aria-expanded', 'true');
        const input = search.querySelector('input[type="search"]');
        if (input) input.focus();
      } else closeSearch(false);
    });
  }
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', () => closeSearch(true)));

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  let cartState = null;
  try { cartState = JSON.parse(($('[data-cart-json]') || {}).textContent || 'null'); } catch (err) { cartState = null; }

  function updateCounts(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
  }

  function lineHTML(item) {
    const imgSrc = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
    const img = imgSrc
      ? `<img class="pp-line__img" src="${esc(imgSrc)}" alt="" width="76" height="76" loading="lazy">`
      : '<span class="pp-line__img"></span>';
    const variant = item.product_has_only_default_variant || !item.variant_title ? '' : `<span class="pp-line__variant">${esc(item.variant_title)}</span>`;
    const props = item.properties ? Object.keys(item.properties).filter((k) => k.charAt(0) !== '_' && item.properties[k]).map((k) => `<span class="pp-line__variant">${esc(k)}: ${esc(item.properties[k])}</span>`).join('') : '';
    const price = item.original_line_price > item.final_line_price
      ? `<s>${formatMoney(item.original_line_price)}</s>${formatMoney(item.final_line_price)}`
      : formatMoney(item.final_line_price);
    return `<li class="pp-line" data-key="${esc(item.key)}">
      <a href="${esc(item.url)}" tabindex="-1" aria-hidden="true">${img}</a>
      <div>
        <a class="pp-line__title" href="${esc(item.url)}">${esc(item.product_title)}</a>${variant}${props}
        <div class="pp-qty" role="group" aria-label="Quantity for ${esc(item.product_title)}">
          <button type="button" data-qty-change="-1" aria-label="Remove one">${icons.minus}</button>
          <input type="number" min="0" inputmode="numeric" value="${item.quantity}" data-qty-input aria-label="Quantity">
          <button type="button" data-qty-change="1" aria-label="Add one">${icons.plus}</button>
        </div><button type="button" class="pp-line__remove" data-remove>Remove</button>
      </div>
      <div class="pp-line__price">${price}</div>
    </li>`;
  }

  function renderCart(cart, error) {
    if (!cart) return;
    cartState = cart;
    updateCounts(cart);
    if (!drawer) return;
    const errBox = $('[data-cart-error]', drawer);
    if (errBox) { errBox.hidden = !error; errBox.textContent = error || ''; }
    const empty = $('[data-cart-empty]', drawer);
    const list = $('[data-cart-items]', drawer);
    const foot = $('[data-cart-foot]', drawer);
    const ship = $('[data-cart-ship]', drawer);
    const n = $('[data-cart-n]', drawer);
    if (n) n.textContent = cart.item_count ? `(${cart.item_count})` : '';
    if (!cart.item_count) {
      empty.hidden = false; list.innerHTML = ''; foot.hidden = true; if (ship) ship.hidden = true;
      return;
    }
    empty.hidden = true; foot.hidden = false;
    list.innerHTML = cart.items.map(lineHTML).join('');
    const sub = $('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = formatMoney(cart.total_price);
    if (ship) {
      const goal = Number(ship.dataset.threshold || 0);
      if (goal > 0) {
        ship.hidden = false;
        const left = goal - cart.total_price;
        $('[data-ship-text]', ship).textContent = left > 0 ? `Add ${formatMoney(left)} more for free shipping` : 'Free shipping unlocked';
        $('[data-ship-bar]', ship).style.width = Math.min(100, (cart.total_price / goal) * 100) + '%';
      } else ship.hidden = true;
    }
  }

  async function fetchCart() {
    const r = await fetch(url('/cart.js'), { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function changeLine(key, quantity) {
    if (!drawer) return;
    drawer.classList.add('is-loading');
    try {
      const r = await fetch(url('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const data = await r.json();
      if (r.ok) renderCart(data);
      else renderCart(await fetchCart(), data.description || data.message || 'That change didn’t save. Try again.');
    } catch (err) {
      renderCart(cartState, 'Couldn’t reach the cart. Check your connection and try again.');
    } finally {
      drawer.classList.remove('is-loading');
    }
  }

  if (drawer) {
    drawer.addEventListener('click', (e) => {
      const line = e.target.closest('[data-key]');
      if (!line) return;
      const input = $('[data-qty-input]', line);
      const step = e.target.closest('[data-qty-change]');
      if (step) changeLine(line.dataset.key, Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyChange)));
      if (e.target.closest('[data-remove]')) changeLine(line.dataset.key, 0);
    });
    drawer.addEventListener('change', (e) => {
      if (!e.target.matches('[data-qty-input]')) return;
      changeLine(e.target.closest('[data-key]').dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  function bumpCartIcon() {
    $$('.pp-cartbtn').forEach((b) => { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
  }

  function addRequest(form) {
    const picked = form.querySelector('[name="pp-bundle"]:checked');
    const mode = picked ? picked.value : 'single';
    if (mode === 'combo') {
      const partner = form.querySelector('[data-partner]');
      const main = form.querySelector('input[name="id"]');
      if (partner && main) {
        return {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(main.value), quantity: 1 }, { id: Number(partner.value), quantity: 1 }] })
        };
      }
    }
    const fd = new FormData(form);
    if (mode === 'duo') fd.set('quantity', '2');
    return { method: 'POST', headers: { Accept: 'application/json' }, body: fd };
  }

  async function addToCart(form, button) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    try {
      const r = await fetch(url('/cart/add.js'), addRequest(form));
      const data = await r.json();
      const cart = await fetchCart();
      if (r.ok) {
        renderCart(cart);
        bumpCartIcon();
        if (button) { button.classList.add('is-added'); window.setTimeout(() => button.classList.remove('is-added'), 1600); }
      } else {
        renderCart(cart, data.description || data.message || 'This item couldn’t be added. Try again.');
      }
      openPanel(drawer);
    } catch (err) {
      form.submit();
    } finally {
      if (button) {
        button.classList.remove('is-loading');
        button.disabled = button.hasAttribute('data-add-btn') && button.dataset.soldout === 'true';
      }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!drawer || !form.matches('form[data-ajax-add], #pp-product-form')) return;
    e.preventDefault();
    addToCart(form, e.submitter || form.querySelector('[type="submit"]'));
  });

  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
    if (!drawer) return;
    e.preventDefault();
    openPanel(drawer);
    fetchCart().then((c) => renderCart(c)).catch(() => {});
  }));
  if (cartState) renderCart(cartState);

  /* ---------- Quantity steppers (product page, cart page) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]');
    if (!b) return;
    const input = b.closest('.pp-qty') && b.closest('.pp-qty').querySelector('input');
    if (!input) return;
    const min = Number(input.min || 0);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + Number(b.dataset.step));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-autosubmit]') && e.target.form) e.target.form.submit();
  });

  /* ---------- Product gallery ---------- */
  const gallery = $('[data-gallery-main]');
  const thumbs = $$('[data-thumb]');
  function markThumb(id) { thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === String(id)))); }
  function goToMedia(id) {
    if (!gallery) return;
    const slide = gallery.querySelector(`[data-media-id="${id}"]`);
    if (!slide) return;
    gallery.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    markThumb(id);
  }
  thumbs.forEach((t) => t.addEventListener('click', () => goToMedia(t.dataset.thumb)));
  if (gallery && thumbs.length) {
    let tid;
    gallery.addEventListener('scroll', () => {
      window.clearTimeout(tid);
      tid = window.setTimeout(() => {
        const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        const slide = gallery.children[i];
        if (slide && slide.dataset.mediaId) markThumb(slide.dataset.mediaId);
      }, 80);
    }, { passive: true });
  }

  /* ---------- Bundle & save picker ---------- */
  const bundle = $('[data-bundle]');
  function bundleMode() {
    const r = bundle && bundle.querySelector('[name="pp-bundle"]:checked');
    return r ? r.value : 'single';
  }
  function refreshBundle(price) {
    if (!bundle) return;
    const keep = Number(bundle.dataset.keep || 100);
    if (price == null) price = Number(bundle.dataset.price || 0);
    bundle.dataset.price = price;
    const set = (sel, cents) => { const el = $(sel, bundle); if (el) el.textContent = formatMoney(cents); };
    const off = (cents) => Math.floor((cents * keep) / 100);
    set('[data-b-single]', price);
    set('[data-b-duo]', off(price * 2));
    set('[data-b-duo-was]', price * 2);
    const p = $('[data-partner]', bundle);
    if (p) {
      const pp = Number(p.tagName === 'SELECT' ? p.selectedOptions[0].dataset.price : p.dataset.price) || 0;
      set('[data-b-combo]', off(price + pp));
      set('[data-b-combo-was]', price + pp);
    }
    const qty = $('.pp-buy .pp-qty');
    if (qty) qty.hidden = bundleMode() !== 'single';
  }
  if (bundle) {
    bundle.addEventListener('change', (e) => {
      if (e.target.matches('[data-partner]')) {
        const combo = bundle.querySelector('[name="pp-bundle"][value="combo"]');
        if (combo) combo.checked = true;
      }
      refreshBundle();
    });
  }

  /* ---------- Product variants ---------- */
  const pform = $('#pp-product-form');
  const pjson = $('[data-product-json]');
  const addBtn = $('[data-add-btn]');
  if (pform && pjson) {
    let product = null;
    try { product = JSON.parse(pjson.textContent); } catch (err) { product = null; }
    const idInput = pform.querySelector('input[name="id"]');
    const addLabel = $('[data-add-label]');
    const priceEl = $('[data-price]');
    const stickyPrice = $('[data-sticky-price]');
    const sets = $$('[data-option-index]', pform);
    const selected = () => sets.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    const findVariant = (sel) => product.variants.find((v) => v.options.every((o, i) => o === sel[i]));

    function update() {
      const sel = selected();
      sets.forEach((fs, i) => {
        const label = fs.querySelector('[data-option-value]');
        if (label && sel[i]) label.textContent = sel[i];
        fs.querySelectorAll('input').forEach((inp) => {
          const test = sel.slice(); test[i] = inp.value;
          const match = findVariant(test);
          inp.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      const v = findVariant(sel);
      if (!v) {
        addBtn.disabled = true; addBtn.dataset.soldout = 'true';
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.dataset.soldout = String(!v.available);
      addLabel.textContent = v.available ? addLabel.dataset.label : 'Sold out';
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceEl) {
        priceEl.classList.toggle('pp-price--sale', !!onSale);
        priceEl.innerHTML = `<span class="pp-price__now">${formatMoney(v.price)}</span>` +
          (onSale ? `<s>${formatMoney(v.compare_at_price)}</s><span class="pp-badge-save">Save ${Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100)}%</span>` : '');
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      refreshBundle(v.price);
      if (v.featured_media) goToMedia(v.featured_media.id);
      const u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState(null, '', u.toString());
    }
    if (product && sets.length) {
      sets.forEach((fs) => fs.addEventListener('change', update));
      update();
    }
  }

  /* ---------- Sticky add-to-cart on mobile ---------- */
  const sticky = $('[data-sticky]');
  if (sticky && addBtn && pform && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(addBtn);
    const sbtn = sticky.querySelector('button');
    if (sbtn) sbtn.addEventListener('click', () => {
      if (addBtn.disabled) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (pform.requestSubmit) pform.requestSubmit(addBtn); else addBtn.click();
    });
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recs]').forEach(async (el) => {
    if (!el.dataset.url) return;
    try {
      const r = await fetch(el.dataset.url);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recs]');
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; el.hidden = false; }
    } catch (err) { /* recommendations are optional */ }
  });

  /* ---------- Collection sorting ---------- */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  }));

  /* ---------- The cat: eyes follow the pointer, tap to pet ---------- */
  const cat = $('[data-cat-eyes]');
  if (cat) {
    const eyes = $$('[data-eye]', cat).map((g) => ({ sclera: g.querySelector('.cat-sclera'), pupil: g.querySelector('[data-pupil]') }));
    if (!reduceMotion) {
      let raf = null; let px = 0; let py = 0;
      const look = () => {
        raf = null;
        eyes.forEach(({ sclera, pupil }) => {
          const r = sclera.getBoundingClientRect();
          const cx = r.left + r.width / 2; const cy = r.top + r.height / 2;
          const a = Math.atan2(py - cy, px - cx);
          const d = Math.min(1, Math.hypot(px - cx, py - cy) / 260);
          pupil.style.transform = `translate(${(Math.cos(a) * 7 * d).toFixed(2)}px, ${(Math.sin(a) * 7 * d).toFixed(2)}px)`;
        });
      };
      window.addEventListener('pointermove', (e) => { px = e.clientX; py = e.clientY; if (!raf) raf = window.requestAnimationFrame(look); }, { passive: true });
    }
    const pet = $('[data-pet]');
    if (pet) {
      let t;
      pet.addEventListener('click', () => {
        pet.classList.remove('is-petted'); void pet.offsetWidth; pet.classList.add('is-petted');
        window.clearTimeout(t);
        t = window.setTimeout(() => pet.classList.remove('is-petted'), 1000);
        const hint = $('[data-pet-hint]');
        if (hint) hint.remove();
      });
    }
  }
})();
